import { BusinessLineModel, SalesItemAttributeModel, SalesItemModel, VisitSalesItemAttributeModel } from "@common/models";
import { BusinessLineName, BusinessLineEnum, SalesItemAttributeProcessingType, VisitSalesItemAttributesName } from "@common/models/Enums";

export class AttributeUtils {

    private static hospitalMedicationAttributeNames: string[] = [
        'QTY:', 'Unit of Measure:', 'Dose:', 'Frequency:',
        'Refills:', 'Instructions:', 'Expiration:', 'Notes:'
    ];

    static generatePredefinedAttributes = (attributeGroup: PredefinedAttributes, salesItem: SalesItemModel) => {
        const attributes: SalesItemAttributeModel[] = [];
        let order = salesItem.salesItemAttributes.length + 1;
        switch (attributeGroup) {
            case PredefinedAttributes.HospitalMedicationAttributes:
                // This is the only attribute with default value for this group.
                attributes.push(new SalesItemAttributeModel({
                    businessLineId: BusinessLineEnum.Hospital,
                    businessLine: new BusinessLineModel({ businessLineId: BusinessLineEnum.Hospital, name: BusinessLineName.Hospital }),
                    salesItemAttributeTypeId: 1,
                    name: 'Prescribed Product:',
                    salesItemAttributeProcessingTypeId: SalesItemAttributeProcessingType.NoProcessing,
                    // Using FullName since "Description" is just a FE Label.
                    defaultValue: salesItem.fullName,
                    sortOrder: order
                }));
                order++;
                AttributeUtils.hospitalMedicationAttributeNames.map(attName => {
                    attributes.push(new SalesItemAttributeModel({
                        businessLineId: BusinessLineEnum.Hospital,
                        businessLine: new BusinessLineModel({ businessLineId: BusinessLineEnum.Hospital, name: BusinessLineName.Hospital }),
                        salesItemAttributeTypeId: 1,
                        name: attName,
                        salesItemAttributeProcessingTypeId: SalesItemAttributeProcessingType.NoProcessing,
                        sortOrder: order,
                    }))
                    order++;
                });
                return attributes;
            default:
                // Do we need to do something here or just break?
                return [];
        }
    }

    static getSalesItemAttributeValueByName = (visitSalesItemAttributes: VisitSalesItemAttributeModel[], nameKey: VisitSalesItemAttributesName, defaultValue = "") => {
        return _.defaultTo(visitSalesItemAttributes.find((v) => v.name == nameKey)?.stringValue, defaultValue)
    }
}

export enum PredefinedAttributes {
    HospitalMedicationAttributes = 0,
}
